import { TeamListItem, UserStatuses } from '../types';

export const isUserDeprovisioned = (user: TeamListItem): boolean => {
  return user.status === UserStatuses.DEPROVISIONED;
};

export const isUserActive = (user: TeamListItem): boolean => {
  return user.status === UserStatuses.ACTIVE;
};

export const isUserProvisioned = (user: TeamListItem): boolean => {
  return user.status === UserStatuses.PROVISIONED;
};

export const canDeactivate = (user: TeamListItem): boolean => {
  return isUserActive(user) || isUserProvisioned(user);
};

export const canDelete = (user: TeamListItem): boolean => {
  return isUserDeprovisioned(user);
};

export const canReactivate = (user: TeamListItem): boolean => {
  return isUserDeprovisioned(user);
};
